export const formatPhoneNumber = (inputNumber) => {
  const match = inputNumber.match(/^\+(\d{2})(\d{3})(\d{3})(\d{2})(\d{2})$/);
  if (match) {
    const [, countryCode, operatorCode, firstPart, secondPart, thirdPart] = match;
    return `+${countryCode} (${operatorCode}) ${firstPart} ${secondPart} ${thirdPart}`;
  } else {
    return inputNumber;
  }
};

export const formatDate = (date) => {
  return new Date(date).toLocaleDateString('uk-UA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};

export const formatPrice = (price) => {
  return price.toLocaleString('uk-UA', {
    minimumFractionDigits: 2,
  });
};

export const formatTime = (time) => {
  return time.toLocaleString('uk-UA', {
    minimumFractionDigits: 1,
  });
};

export const convertToCalendarDate = (date) => {
  const utcDate = new Date(date);
  const localDate = new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60000);
  return localDate.toISOString().split('T')[0];
};

export const roundToNextHour = (date) => {
  const roundedDate = new Date(date);
  roundedDate.setMilliseconds(0);
  roundedDate.setSeconds(0);
  roundedDate.setMinutes(0);
  roundedDate.setHours(roundedDate.getHours() + 1);
  return roundedDate;
};
